import service from '@/utils/request'; // CreateBairunStationBasePrice 添加油站挂牌价
// @Tags Price
// @Summary 添加油站挂牌价
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunRequest.BairunStationBasePriceRequest true "添加油站挂牌价"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /priceManage/stationBasePrice/create [post]

export var createBairunStationBasePrice = function createBairunStationBasePrice(data) {
  return service({
    url: '/priceManage/stationBasePrice/create',
    method: 'post',
    data: data
  });
}; // DeleteBairunStationBasePrice 删除油站挂牌价
// @Tags Price
// @Summary 删除油站挂牌价
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunRequest.BairunStationBasePriceRequest true "删除油站挂牌价"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"删除成功"}"
// @Router /priceManage/stationBasePrice/delete [delete]

export var deleteBairunStationBasePrice = function deleteBairunStationBasePrice(data) {
  return service({
    url: '/priceManage/stationBasePrice/delete',
    method: 'post',
    data: data
  });
}; // DeleteBairunStationBasePriceByIds 批量删除油站挂牌价
// @Tags Price
// @Summary 批量删除油站挂牌价
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.IdsReq true "批量删除油站挂牌价"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"批量删除成功"}"
// @Router /priceManage/stationBasePrice/deleteByIds [delete]

export var deleteBairunStationBasePriceByIds = function deleteBairunStationBasePriceByIds(data) {
  return service({
    url: '/priceManage/stationBasePrice/deleteByIds',
    method: 'post',
    data: data
  });
}; // UpdateBairunStationBasePrice 更新油站挂牌价
// @Tags Price
// @Summary 更新油站挂牌价
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunRequest.BairunStationBasePriceRequest true "更新油站挂牌价"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"更新成功"}"
// @Router /priceManage/stationBasePrice/update [put]

export var updateBairunStationBasePrice = function updateBairunStationBasePrice(data) {
  return service({
    url: '/priceManage/stationBasePrice/update',
    method: 'put',
    data: data
  });
}; // FindBairunStationBasePrice 查找油站挂牌价
// @Tags Price
// @Summary 查找油站挂牌价
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body model.BairunStationBasePrice true "查找油站挂牌价"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"查询成功"}"
// @Router /priceManage/stationBasePrice/find [get]

export var findBairunStationBasePrice = function findBairunStationBasePrice(params) {
  return service({
    url: '/priceManage/stationBasePrice/find',
    method: 'get',
    params: params
  });
}; // GetBairunStationBasePriceList 分页获取油站挂牌价
// @Tags Price
// @Summary 分页获取油站挂牌价
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.BairunStationBasePriceSearch true "分页获取油站挂牌价"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /priceManage/stationBasePrice/getList [get]

export var getBairunStationBasePriceList = function getBairunStationBasePriceList(params) {
  return service({
    url: '/priceManage/stationBasePrice/getList',
    method: 'get',
    params: params
  });
}; // getBairunStationAllBasePrice 获取油站所有油品挂牌价
// @Tags Price
// @Summary 获取油站所有油品挂牌价
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.getBairunStationAllBasePrice true "获取油站所有油品挂牌价"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /priceManage/stationBasePrice/infoList [get]

export var getBairunStationAllBasePrice = function getBairunStationAllBasePrice(params) {
  return service({
    url: '/priceManage/stationBasePrice/infoList',
    method: 'get',
    params: params
  });
};